export const DEFAULT_PROTOCOL = 'https://';
export const HTTP_PROTOCOL = 'http://';
